import React from 'react';
import { ArrowUpRight, ArrowDownRight, Search, Filter } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { mockTransactions, formatCurrency, formatDate } from '@/utils/mockData';

export default function TransactionsPage() {
  return (
    <div className="max-w-4xl mx-auto" data-testid="transactions-page">
      <div className="mb-6">
        <h1 className="text-3xl font-bold font-heading text-slate-900">Transaction History</h1>
        <p className="text-slate-600 mt-1">View all your account activities</p>
      </div>

      <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-200 mb-6">
        <div className="flex items-center gap-4">
          <div className="relative flex-1">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
            <Input placeholder="Search transactions..." data-testid="search-transactions-input" className="pl-10 h-12 rounded-lg" />
          </div>
          <Button variant="outline" data-testid="filter-btn" className="rounded-lg h-12 px-6">
            <Filter className="w-5 h-5 mr-2" />
            Filter
          </Button>
        </div>
      </div>

      <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-200">
        <div className="space-y-2">
          {mockTransactions.map((txn) => (
            <div key={txn.id} data-testid={`transaction-row-${txn.id}`} className="flex items-center gap-4 p-4 rounded-xl hover:bg-slate-50 transition-colors border border-transparent hover:border-slate-200">
              <div className={`w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 ${txn.type === 'credit' ? 'bg-green-100 text-green-600' : 'bg-red-100 text-red-600'}`}>
                {txn.type === 'credit' ? <ArrowDownRight className="w-6 h-6" /> : <ArrowUpRight className="w-6 h-6" />}
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-slate-900 truncate">{txn.description}</p>
                <p className="text-sm text-slate-600">{formatDate(txn.date)}</p>
              </div>
              <div className="text-right">
                <p className={`font-bold text-lg ${txn.type === 'credit' ? 'text-green-600' : 'text-red-600'}`}>
                  {txn.type === 'credit' ? '+' : '-'}{formatCurrency(txn.amount)}
                </p>
                <p className="text-xs text-slate-500 capitalize">{txn.status}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
